import classNames from "classnames";
import React from "react";

import { flexDirectionClass, IStylePadding, IStyleSize, paddingClass, sizeClass } from "../Style";

type Style = IStylePadding & IStyleSize;

interface ITabPanelProps extends Partial<Style> {
  className?: string;
}

export class TabPanel extends React.PureComponent<ITabPanelProps> {
  static defaultProps: Partial<ITabPanelProps> = {
    size: "md",
    padding: [true],
  };

  render() {
    const { children, className, padding, size, ...proxiedStyles } = this.props;
    const classes = classNames(
      "el-tab-panel__item",
      flexDirectionClass("column"),
      sizeClass(size),
      paddingClass(padding),
      className,
    );

    return (
      <div className={classes} {...proxiedStyles}>
        {children}
      </div>
    );
  }
}
